import { IObjectMap } from '@anchor-solutions-nl/translator-as';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss']
})
export class ImagePreviewComponent implements OnInit {
  public width = '100%';

  constructor(
    public dialogRef: MatDialogRef<ImagePreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { url: string; radius: string; },
  ) { }

  ngOnInit(): void { }

  public getStyle(): IObjectMap<string> {
    const style: IObjectMap<string> = {};

    style['border-radius'] = this.data.radius || '0';

    return style;
  }
}
